import { useState } from 'react'
import { DisplayUserLink, Modal } from 'ComponentLibrary'
import { Stack } from '@mui/material'
import { Mandator } from 'ComponentLibrary/src/molecules/MandatorList/types'
import { MandatorForm, type MandatorFormLabels } from 'ComponentLibrary/src/molecules/MandatorList/MandatorForm'
import { MenuOption } from 'ComponentLibrary/src/atoms/Options/OptionsMenu'
import { BuildingOfficeIcon, PencilSimpleIcon, TrashIcon } from '@phosphor-icons/react'
import { IconButtonWithOptions } from 'ComponentLibrary/src/piazza'

type ReadOnlyMandatorListItemProps = {
    mandator: Mandator
    updateMandator?: undefined
    deleteMandator?: undefined
    copy?: undefined
}

type EditableMandatorListItemProps = {
    mandator: Mandator
    updateMandator?: (updatedContact: Mandator) => void
    deleteMandator?: () => void
    copy: MandatorListItemCopy
}

type MandatorListItemProps = ReadOnlyMandatorListItemProps | EditableMandatorListItemProps

export type MandatorListItemCopy = {
    edit: string
    delete: string
    editModalTitle: string
    formLabels: MandatorFormLabels
}

export function MandatorListItem({ mandator, updateMandator, deleteMandator, copy }: MandatorListItemProps) {
    const [isEditingMandator, setIsEditingMandator] = useState(false)

    const handleFormSubmit = (data: Mandator) => {
        updateMandator?.(data)
        setIsEditingMandator(false)
    }

    const handleFormCancel = () => {
        setIsEditingMandator(false)
    }

    const options: MenuOption[] = []

    if (updateMandator && copy) {
        options.push({ title: copy.edit, icon: <PencilSimpleIcon />, callback: () => setIsEditingMandator(true) })
    }
    if (deleteMandator && copy) {
        options.push({
            title: copy.delete,
            icon: <TrashIcon />,
            callback: deleteMandator,
            danger: true,
        })
    }

    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
            <DisplayUserLink
                user={{ ...mandator, first_name: mandator.name }}
                showAddressInsteadOfOrganization
                maxWidth="350px"
                defaultIcon={<BuildingOfficeIcon />}
            />
            {options.length > 0 && <IconButtonWithOptions size="small" variant="tertiary" options={options} />}
            {copy && (
                <Modal isOpen={isEditingMandator} onClose={handleFormCancel} title={copy.editModalTitle} showCloseIcon>
                    <MandatorForm
                        onCancelCallback={handleFormCancel}
                        onSubmitCallback={handleFormSubmit}
                        mandator={mandator}
                        labels={copy.formLabels}
                    />
                </Modal>
            )}
        </Stack>
    )
}
